var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitlabSmallInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "75uvumtcla"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.784314 0 0 0 0 0.815686 0 0 0 0 0.874510 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#75uvumtcla)",
    transform: "translate(-788 -100) translate(47 82) translate(681 14) translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M8.423 15.511L11.523 5.969 5.322 5.969 8.423 15.511z",
    transform: "translate(56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M8.423 15.51L5.322 5.969 0.978 5.969z",
    transform: "translate(56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M.978 5.97L.036 8.868c-.086.264.008.554.233.717l8.154 5.925L.978 5.969z",
    transform: "translate(56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M.978 5.97h4.344L3.455.221c-.096-.295-.514-.295-.61 0L.978 5.97z",
    transform: "translate(56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M8.423 15.51L11.523 5.969 15.868 5.969 8.423 15.51z",
    transform: "translate(56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "M15.868 5.97l.942 2.899c.086.264-.008.554-.233.717l-8.154 5.925 7.445-9.542z",
    transform: "translate(56)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "M15.868 5.97h-4.345L13.39.221c.096-.295.514-.295.61 0l1.868 5.747z",
    transform: "translate(56)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabSmallInactive);
export default __webpack_public_path__ + "static/media/gitlab-small-inactive.a7975088.svg";
export { ForwardRef as ReactComponent };